import React, {Component} from 'react';
import {Link, Switch, Route } from 'react-router-dom';
import {withRouter} from 'react-router';

import Update from './Update';
import Logout from './Logout';
import { connect } from 'react-redux'

class Account extends Component {
  render() {   

    return (
        <Switch>
            <Route path="*/update" name="Clients" render={(location) => <Update />}/>
            <Route path="*/logout" name="Clients" render={(location) => <Logout />}/> 
        </Switch>
    );
  }
}
 
function mapStateToProps(state, ownProps) {
 
    return {
        user: state.UserReducer    
    }
}

export default withRouter(connect(mapStateToProps)(Account))



// WEBPACK FOOTER //
// ./src/components/Account/index.js